// Hook personalizado para obtener configuraciones de envío
// Proporciona acceso reactivo a las configuraciones de envío

import { useState, useEffect } from 'react'
import { getShippingSettings } from '../services/shipping.service'

/**
 * Hook useShipping
 * Obtiene las configuraciones de envío desde Firestore
 * @returns {Object} { settings, loading, error, refetch }
 */
export const useShipping = () => {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchSettings = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getShippingSettings()
      setSettings(data)
    } catch (err) {
      console.error('Error obteniendo configuraciones de envío:', err)
      setError(err.message || 'Error al cargar configuraciones de envío')
      // Usar valores por defecto en caso de error
      setSettings({
        freeShippingMinAmount: 50000,
        freeShippingMaxDistance: null,
        defaultShippingCost: 15000,
        enabled: true,
        fulfillment: { homeDeliveryEnabled: true, pickupEnabled: false, pickupWarehouseIds: [] },
        distancePricing: {
          originAddress: { street: '', apartment: '', city: '', postalCode: '', province: '', country: 'ARGENTINA' },
          originCoordinates: null,
          tiers: [],
          negotiationDistance: null,
          negotiationEnabled: false
        }
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [])

  return {
    settings,
    loading,
    error,
    refetch: fetchSettings
  }
}

export default useShipping

